import React from "react";
import ContentLeft from "./ContentLeft";
import ContentRight from "./ContentRight";

const Content = () => <div className="wk-banner-content">
  <ContentLeft />
  <ContentRight />
</div>;
export default Content;
